import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-828308d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { style: {"margin-top":"8px"} }
const _hoisted_3 = ["alt", "src"]
const _hoisted_4 = ["src"]

import {reactive, onMounted, watch} from "vue";
import {message, UploadFile, UploadProps} from "ant-design-vue";
import {PlusOutlined} from "@ant-design/icons-vue";
import {account} from "@/app/login";
import {Json, req} from "@/lib/util";


export default /*#__PURE__*/_defineComponent({
  __name: 'ImagesUploader',
  props: {
    images: {},
    max: {},
    imageSizeLimit: {},
    title: {}
  },
  emits: ['update:images'],
  setup(__props: any, { emit: __emit }) {


const props = __props
const emits = __emit

const info = reactive({
  fileList: [] as UploadFile[],
  data: {key: '', token: ''},
  preview: {visible: false, title: '', image: ''}
})

onMounted(() => {
  info.fileList = props.images.map(i => {
    return {
      status: 'done',
      url: i,
      thumbUrl: i.endsWith('mp4') ? require('@/assets/image/mp4.png') : i.includes('dummyimage.com') ? i : `${i}-sq.200`
    } as UploadFile
  })
  watch(() => props.images, () => {
    info.fileList = props.images.map(i => {
      return {
        status: 'done',
        url: i,
        thumbUrl: i.endsWith('mp4') ? require('@/assets/image/mp4.png') : i.includes('dummyimage.com') ? i : `${i}-sq.200`
      } as UploadFile
    })
  })
})


const isImageUrl = (f: UploadFile): boolean => {
  if (f.thumbUrl?.includes('dummyimage.com')) return true
  return !!f.thumbUrl?.endsWith('-sq.200');
}

const beforeUpload = (f: File): Promise<File> | boolean => {
  if (!account.shop?.sid) {
    message.warn({content: '账号异常，请重新登录'})
    return false
  }

  info.data.key = `media/temp/${Math.random().toString(36).slice(2)}.${f.name.split('.').pop()}`
  if (f.name.endsWith('mp4')) {
    if (f.size > 100 * 1000 * 1000) {
      message.warn({content: '文件尺寸过大'})
      return false
    }
  } else if (f.size > 10 * 1000 * 1000) {
    message.warn({content: '图片尺寸过大'})
    return false
  }
  return new Promise((resolve, reject) => {
    if (props.imageSizeLimit && f.type.includes('image')) {
      const r = new FileReader()
      r.onload = (ev) => {
        if (ev.target) {
          const img = new Image()
          img.onload = () => {
            if (props.imageSizeLimit && props.imageSizeLimit.includes('x')) {
              const arr = props.imageSizeLimit.split('x')
              if (arr[0] != `${img.width}` || arr[1] != `${img.height}`) {
                message.error(`图片宽高必须要等于${props.imageSizeLimit}`)
                reject()
                return
              } else return getToken(f, resolve, reject)
            } else if (props.imageSizeLimit && props.imageSizeLimit.includes(':')) {
              const arr = props.imageSizeLimit.split(':')
              if (Number(arr[0]) / Number(arr[1]) != img.width / img.height) {
                console.log(arr, Number(arr[0]), Number(arr[1]), img.width, img.height)
                console.log(Number(arr[0]) / Number(arr[1]), img.width / img.height)
                message.error(`图片宽高比必须要等于${props.imageSizeLimit}`)
                reject()
                return
              } else return getToken(f, resolve, reject)
            } else {
              message.error(`图片限制格式错误`)
              reject()
              return
            }
          }
          img.onerror = (err) => {
            message.error(err.toString())
            reject()
            return
          }
          img.src = ev.target.result as string
        } else {
          message.error(`图片限制格式错误`)
          reject()
        }
      }
      r.onerror = () => {
        message.error('读取本地文件错误')
        reject()
        return
      }
      r.readAsDataURL(f)
    } else return getToken(f, resolve, reject)
  })
}

const getToken = (f: File, resolve: (value: (PromiseLike<File> | File)) => void, reject: (reason?: any) => void) => {
  req({
    url: 'fs/token', method: 'POST', data: {key: info.data.key}, success: rs => {
      info.data = Object.assign(info.data, rs)
      resolve(f)
    }, fail: reject
  })
}

const onUploadChange = (j: Json) => {
  const f = j.file as UploadFile
  if (f.status == 'done') {
    console.log(f)
    f.url = `https://activity.guandb.cn/${info.data.key}`
    if (f.url.endsWith('mp4')) f.thumbUrl = require('@/assets/image/mp4.png')
    else f.thumbUrl = f.url + '-sq.200'
    emits('update:images', info.fileList.map(i => i.url))
  } else if (f.status == 'removed') emits('update:images', info.fileList.map(i => i.url))
  else if (f.status == undefined) {
    info.fileList.pop()
  }
}

function getBase64(file: File) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

const handleCancel = () => {
  info.preview.visible = false;
  info.preview.title = '';
}

const handlePreview = async (file: UploadProps['fileList'][number]) => {
  if (!file.url && !file.preview) {
    file.preview = (await getBase64(file.originFileObj)) as string;
  }
  info.preview.image = file.url || file.preview;
  info.preview.visible = true;
  info.preview.title = file.name || file.url.substring(file.url.lastIndexOf('/') + 1);
};


return (_ctx: any,_cache: any) => {
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_upload, _mergeProps({
      "file-list": info.fileList,
      "onUpdate:fileList": _cache[0] || (_cache[0] = ($event: any) => ((info.fileList) = $event)),
      "list-type": "picture-card",
      data: info.data,
      accept: ".jpg,.jpeg,.mp4,.png,.gif",
      "before-upload": beforeUpload,
      action: "https://activity-guandb-cn.oss-cn-shanghai.aliyuncs.com",
      "max-count": _ctx.max,
      "show-upload-list": {showRemoveIcon:true,showDownloadIcon:false},
      "is-image-url": isImageUrl,
      onChange: onUploadChange,
      onPreview: handlePreview
    }, _ctx.$attrs), {
      default: _withCtx(() => [
        (info.fileList.length < _ctx.max)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_unref(PlusOutlined)),
              _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title ?? '上传'), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 16, ["file-list", "data", "max-count"]),
    _createVNode(_component_a_modal, {
      open: info.preview.visible,
      "onUpdate:open": _cache[1] || (_cache[1] = ($event: any) => ((info.preview.visible) = $event)),
      title: info.preview.title,
      footer: null,
      onCancel: handleCancel
    }, {
      default: _withCtx(() => [
        (info.preview.image.split('.').pop() != 'mp4')
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              alt: info.preview.title,
              src: info.preview.image,
              style: {"width":"100%"}
            }, null, 8, _hoisted_3))
          : (_openBlock(), _createElementBlock("video", {
              key: 1,
              src: info.preview.image,
              controls: "",
              style: {"width":"100%"}
            }, null, 8, _hoisted_4))
      ]),
      _: 1
    }, 8, ["open", "title"])
  ], 64))
}
}

})